import React, { useCallback, useMemo, useState } from 'react';
import { assertUnreachable } from 'utils/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import SortBySelector from './SortBySelector';
const getNewSortMethod = (sortMethod, type) => {
    if (type === 'Merchant') {
        switch (sortMethod) {
            case 'Alphabetical':
                return 'Frequency';
            case 'Frequency':
                return 'Alphabetical';
            default: {
                return 'Alphabetical';
            }
        }
    }
    switch (sortMethod) {
        case 'Alphabetical':
            return 'Recent';
        case 'Frequency':
            return 'Alphabetical';
        case 'Recent':
            return 'Frequency';
        default: {
            assertUnreachable(sortMethod);
            return 'Recent';
        }
    }
};
export const useSortBySelector = (type) => {
    const dispatch = useAppDispatch();
    const initialSortMethod = useAppSelector((state) => state.deviceSettings.transactionSortMethod);
    const [sortMethod, setSortMethod] = useState(type === 'Transaction' ? initialSortMethod || 'Frequency' : 'Alphabetical');
    const handleSortMethodChange = useCallback(() => {
        setSortMethod((oldSortMethod) => {
            const newSortMethod = getNewSortMethod(oldSortMethod, type);
            if (type === 'Transaction') {
                dispatch(setDeviceSettingsKey('transactionSortMethod', newSortMethod));
            }
            return newSortMethod;
        });
    }, [type]);
    const Button = useMemo(() => (<SortBySelector sortMethod={sortMethod} onPress={handleSortMethodChange}/>), [handleSortMethodChange, sortMethod]);
    return {
        Button,
        sortMethod,
    };
};
